import { render, staticRenderFns } from "./pedDocumentos.vue?vue&type=template&id=18d502b7&"
import script from "./pedDocumentos.vue?vue&type=script&lang=js&"
export * from "./pedDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports